// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__37woT","col":"Table_col__2epaR","fulfillmentStatus":"Table_fulfillmentStatus__-SUFC","emailCol":"Table_emailCol__296L4"};